import script from "./BirthplacePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthplacePicker.vue?vue&type=script&setup=true&lang=js"

import "./BirthplacePicker.vue?vue&type=style&index=0&id=51235856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51235856"]])

export default __exports__